import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import {
  bootstrapFirebaseFromEnv,
  consumeCrossPanelHandoff,
  initSentry,
} from "@workspace/admin-ui";

initSentry({
  appName: "chain-admin",
  env: import.meta.env as unknown as Record<string, string | undefined | boolean>,
});

bootstrapFirebaseFromEnv(
  import.meta.env as Record<string, string | undefined>,
  "artifacts/chain-admin",
);

// Cross-panel role switch may hand this tab a fresh session — consume it
// before the auth listener mounts so we never flash the login screen.
await consumeCrossPanelHandoff();

createRoot(document.getElementById("root")!).render(<App />);
